var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPolicies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.042,
    height: 18.001,
    viewBox: "0 0 18.042 18.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_policies",
    transform: "translate(-0.454 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2498",
    "data-name": "Path 2498",
    d: "M.5,0h18V18H.5Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2499",
    "data-name": "Path 2499",
    d: "M7.5,9a2.951,2.951,0,0,0,3,2h4c2.431,0,3.584,1.6,4,4a2.623,2.623,0,0,1,2,3c-.231,1.457-.525,3-2,3-1.441,0-2.73-.585-3-2s-.34-3.47,1-4c-.357-1.3-.647-2-2-2h-4a4.978,4.978,0,0,1-3-1v3c1.378.487,1.247,2.559,1,4s-.538,2-2,2-2.753-.559-3-2,.622-3.513,2-4V9a2.68,2.68,0,0,1-2-3c.231-1.432.549-2.972,2-3s2.714.577,3,2S8.846,8.465,7.5,9Zm-1-2a1,1,0,1,0-1-1A1,1,0,0,0,6.5,7Zm0,12a1,1,0,1,0-1-1A1,1,0,0,0,6.5,19Zm12,0a1,1,0,1,0-1-1A1,1,0,0,0,18.5,19Z",
    transform: "translate(-3.001 -3.002)",
    fill: "#003fb9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPolicies);
export default __webpack_public_path__ + "static/media/ic_policies.093bfa183eabd02acd579dde060b819c.svg";
export { ForwardRef as ReactComponent };